/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
 // export const urls1="https://test.api.future.welaiedu.cn/future"
 // export const urls="https://test.api.future.welaiedu.cn/evaluate"

export const urls="https://api.future.welaiedu.cn/evaluate"
export const urls1="https://api.future.welaiedu.cn/future"
import { POST, BASE_URL, } from '../api/index'
//正式/测试地址
export const siteurl='https://alive.welaiedu.cn/'
// export const siteurl='http://beta.alive.welaiedu.cn/'
//获取直播课表【分页】
export function courseonlinelist(params) {
	return POST(urls1+'/course/lesson/on-line/list', params, 'get', '')
}
//字典
export function dictcode(params) {
	return POST(urls+'/dict/code', params, 'get', '')
}
//轮播
export function advlist(params) {
	return POST(urls+'/adv/list', params, 'get', '')
}
//获取课程详情（含课时）
export function courseid(params) {
	return POST(urls1+'/lesson/get-lesson', params, 'get', '')
}
//课程详情-点赞
export function lessonzan(params) {
	return POST(urls1+'/lesson/zan?lessonId='+params.lessonId, '', 'post', '')
}
//课程详情-新增浏览量
export function lessonview(params) {
	return POST(urls1+'/lesson/set-view?lessonId='+params.lessonId, '', 'post', '')
}
//微信公众号--微信分享
export function getShareInfo(params) {
	return POST(urls1+'/wx/getWeixinShare', params, 'get', '')
}
//微信公众号--获取公众号二维码的Url
export function wxgetWeixinQrUrl(params) {
	return POST(urls1+'/wx/getWeixinQrUrl', params, 'get', '')
}
//课程详情-获取直播状态
export function lessongetLiveStatus(params) {
	return POST(urls1+'/lesson/getLiveStatus', params, 'get', '')
}
//退出登录
export function UserLogout() {
	return POST(urls + '/user/logout', '', 'post', '')
}

//获取登陆用户信息
export function usercenterinfo() {
	return POST(urls + '/usercenter/get-info', '', 'get', '')
}
//用户登录接口
export function userlogin(params) {
	return POST(urls + '/user/login', params, 'post', '', 4)
}
//f分类
export function courseclassify(params) {
	return POST(urls1+'/course/classify/list?groupId=1&parentId=0&classifyLevel=' + (params && params.classifyLevel ? params.classifyLevel : ''), '', 'get', '')
}
//获取课程列表
export function courselist(params) {
  return POST(urls1 + '/course/list', params, 'get', '')
}
//获取名师列表
export function famous_teacher_list(params) {
  return POST(urls1 + '/course/famous-teacher/list', params, 'get', '')
}
//获取名师课件列表
export function getCoursewareList(params) {
  return POST(urls1 + '/course/famous-teacher/' + params.teacherId + '/res/list', params, 'get', '')
}
//观课记录-获取课程列表
export function notelist(params) {
	return POST(urls1 + '/note/list', params, 'get', '')
}
//POST /usercenter/modify-password-by-old修改密码
export function usercenterpassword(params) {
    return POST(urls+'/usercenter/modify-password-by-old', params, 'post', '',4)
}
//POST /user/forget-checkuser忘记密码1——验证账号
export function usercheckuser(params) {
    return POST(urls+'/user/forget-checkuser',params, 'post', '',4)
}
//POST /user/forget-modify-password忘记密码2-修改密码
export function userpassword(params) {
    return POST(urls+'/user/forget-modify-password',params, 'post')
}
export function userquestions() {
    return POST(urls+'/user/get-questions','', 'get')
}
//POST /user/set-questions找回密码问题设置接口
export function userquestionspost(params) {
    return POST(urls+'/user/set-questions',params)
}
//观课记录-查询是否已添加观课记录【有则返回观课记录】
export function notecheckIsExist(params) {
	return POST(urls1 + '/note/checkIsExist', params, 'get', '')
}
//观课记录-添加/更新一条观课记录
export function note(params) {
	return POST(urls1+'/note', params, 'post', '')
}
// //获取课时详情【课时ID】
// export function courselesson(params) {
// 	return POST(urls+'/lesson/get-lesson', params, 'get', '')
// }
//课程详情-新增浏览量
export function lessonsetview(params) {
	return POST(urls1+'/lesson/set-view?lessonId='+params.lessonId, '', 'post', '')
}
//获取课程详情（含课时）
export function courseparams(params) {
	return POST(urls1+'/course/'+params.id, params, 'get', '')
}
//小程序code自动登录
export function userwxlogin(params) {
	return POST(urls+'/user/wx/login', params, 'post', '',4)
}
//申报录课--分页查询当前教师的申报录课记录列表
export function declaregetDeclareListByCreatorId(params) {
	return POST(urls1+'/declare/getDeclareListByCreatorId', params, 'get', '')
}
//获取教师所教学科列表
export function teachersubjectlist(params) {
	return POST(urls+'/teacher/subject/list-by-work', params, 'get', '')
}
//申报录课--查询校区列表
export function declareselectListByGroupId(params) {
	return POST(urls1+'/declare/selectListByGroupId', params, 'get', '')
}
//根据学校ID获取年级列表
export function gradegradelist(params) {
	return POST(urls+'/grade/gradelist', params, 'get', '')
}
//申报录课---保存申报录课记录
export function declaresaveDeclareVideoTape(params) {
	return POST(urls1+'/declare/saveDeclareVideoTape', params, 'post', '')
}
//申报录课--上传申报录课反思
export function declareuploadCourseReflect(params) {
	return POST(urls1+'/declare/uploadCourseReflect', params, 'get', '')
}
//观看记录--用户进入观看直播
export function declareintoInsert(params) {
	return POST(urls1+'/declare/intoInsert', params, 'post', '')
}
//观看记录--用户退出观看直播
export function declarequitUpate(params) {
	return POST(urls1+'/declare/quitUpate', params, 'post', '')
}
//小程序账号密码登录接口
export function login(params) {
	return POST(urls + '/user/wx/accountLogin', params, 'post', '')
}
//查询学校所有课程
export function subjectgetSubjectBySchoolId(params) {
	return POST(urls+'/subject/getSubjectBySchoolId', params, 'get', '')
}
//小程序账号退出
export function usewxrlogout(params) {
	return POST(urls+'/user/wx/logout', params, 'post', '',4)
}
//修改头像，姓名
export function usercentermodifyheadur(params) {
	return POST(urls+'/usercenter/modify-headurl', params, 'post', '',4)
}
export const fileossupload=urls+'/file/oss-upload'
//根据手机号获取教师信息
export function teachergetTeacherByMobile(params) {
	return POST(urls+'/teacher/getTeacherByMobile', params, 'get', '')
}
//短信服务--发送短信验证码
export function aliyunSmssendSmsCode(params) {
	return POST(urls+'/aliyunSms/sendSmsCode', params, 'get', '')
}
//修改密码--通过短信验证码修改密码
export function usermodifyPasswordByCode(params) {
	return POST(urls+'/user/modifyPasswordByCode', params, 'post', '')
}
//课程详情-获取评论-分页
export function lessonfeelinglist(params) {
	return POST(urls1+'/lesson/feeling/list', params, 'get', '')
}
//课程详情-新增评论
export function lessonfeeling(params) {
	return POST(urls1+'/lesson/feeling', params, 'post', '')
}
//观看记录--观众列表信息
export function declareviewerWatchRecord(params) {
	return POST(urls1+'/declare/viewerWatchRecord', params, 'get', '')
}
//课程详情-删除一条评论
export function lessonfeelingid(params) {
	return POST(urls1+'/lesson/feeling/deleteById?feelingId='+params.feelingId, '', 'post', '')
}
//主题讨论-评论点赞
export function lessonfeelingzan(params) {
	return POST(urls1+'/lesson/feeling/zan', params, 'post', '',4)
}
//主题讨论-取消评论点赞
export function lessonfeelingcancelZan(params) {
	return POST(urls1+'/lesson/feeling/cancelZan', params, 'post', '',4)
}
// 获取年级列表
export function getGradeList(params) {
  return POST(urls + `/grade/gradelist`, params, 'get')
}
// 获取学科列表
export function getSubjectList(params) {
  return POST(urls + `/subject/list`, params, 'get')
}



// WEBPACK FOOTER //
// ./src/api/home.js